import classes from '@/components/Shares/Button.module.css';
import { Icons } from '@/components/Shares/Icons';
import { useLingui } from '@lingui/react';
import { Button, Group } from '@mantine/core';
export const PlayButton: React.FC = () => {
  const {
    i18n
  } = useLingui();
  return <Group w="100%" justify="center" mt={20}>
      <Button w={{
      base: '50%',
      sm: '40%'
    }} fz="xs" radius="sm" size="md" p={0} leftSection={<Icons className="icon-pr-line-log-in" color="var(--mantine-color-dark-4)" fontSize={24} />} tt="uppercase" classNames={{
      root: classes.root
    }} type="submit">
        {i18n._('Start playing!')}
      </Button>
    </Group>;
};